export default __webpack_public_path__ + "static/layout-example-sideNav-dark-bc5359f785690148626b6c1daa053062.png";